import React from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { Fade } from "@progress/kendo-react-animation";

/**
 * Renders a fullscreen loader centered both vertically and horizontally,
 * with optional spinner sizing and theme.
 */
const FullscreenLoader: React.FC = () => {
  return (
    <Fade>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <Loader type="infinite-spinner" size="large" themeColor="primary" />
      </div>
    </Fade>
  );
};

export { FullscreenLoader };
